import Head from "next/head";
/**
 * 具有分享功能容器
 */
interface HeadMetaContainerProp {
	title?: string;
	description?: string;
	imageUrl?: string;
	children?: React.ReactNode;
}
export default function HeadMetaContainer({
	title,
	description,
	imageUrl = "https://web-cdn.rockflow.tech/h5/logo.png",
	children,
}: HeadMetaContainerProp) {
	return (
		<>
			<Head>
				<meta property="og:type" content="website" />
				<meta property="og:title" content={title} />
				<meta property="og:description" content={description} />
				<meta property="og:image" content={imageUrl} />
				<meta property="og:image:width" content="600" />
				<meta property="og:image:height" content="600" />

				<meta name="twitter:title" content={title} />
				<meta name="twitter:description" content={description} />
				<meta name="twitter:image" content={imageUrl} />
				<meta name="twitter:card" content="summary_large_image"></meta>
				<meta name="telegram:channel" content="@telegram" />
				<title>{title}</title>
			</Head>

			{children}
		</>
	);
}
